"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enrichEvent = exports.enrichEventsWithCompetitorsLogos = void 0;
const enrichEventsWithCompetitorsLogos = (competitors, logos) => competitors.map((competitor) => {
    var _a;
    return ({
        ...competitor,
        competitorLogo: ((_a = logos[competitor.id]) === null || _a === void 0 ? void 0 : _a.logo) || undefined,
    });
});
exports.enrichEventsWithCompetitorsLogos = enrichEventsWithCompetitorsLogos;
const enrichEvent = (event, logos) => event
    ? {
        ...event,
        competitors: (0, exports.enrichEventsWithCompetitorsLogos)(event.competitors, logos),
    }
    : null;
exports.enrichEvent = enrichEvent;
//# sourceMappingURL=utils.js.map